import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss']
})
export class EventComponent {
  id: string = "";
  startTime: number | undefined
  constructor(private route: ActivatedRoute){
    
  }

  ngOnInit(): void {
    this.route.paramMap
    .subscribe(params => {
      this.id = params.get("id")??"";
    })
    this.route.queryParamMap.subscribe(queryParams =>{
      this.startTime = Number(queryParams.get('start_time'));
      console.log(this.startTime)
      // if (this.id) {
      //   this.loadData();
      // }
    })
  }
}
